export const MACRO_PLACEHOLDER_DELIMITER_LEFT = '<';
export const MACRO_PLACEHOLDER_DELIMITER_RIGHT = '>';
